import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks";

export default function NoResults() {
    const { response: { query } } = useAppState();

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api
            .createRecommendationRequest({ includeTagging: true })
            .setElements([ "noresults-nosto-1" ])
            .load({ skipPageViews: true, skipEvents: true })
        })
    }, [])

    return (
        <>
            <div class="ns-noresults">
                <div class="ns-noresults-text">No results found for '{query}'</div>
            </div>
            <div class="nosto_element" id="noresults-nosto-1"></div>
        </>
    )
}
